export default __webpack_public_path__ + "static/media/next_enabled.525daa32.svg";